import { __assign, __rest } from "tslib";
// DS3.1
import React from 'react';
import InputErrorMessage from '../../InputErrorMessage';
import InputField from '../../InputField';
import InputHint from '../../InputHint';
import InputLabelSubText from '../../InputLabelSubText';
import InputLabelText from '../../InputLabelText';
import InputSuccessMessage from '../../InputSuccessMessage';
import FormElement from '../../layouts/FormElement';
import LimitedTextInputField from '../../LimitedTextInputField';
/**
 * A single line input field with a label and some details.
 */
var TextInput = React.forwardRef(function (_a, ref) {
    var id = _a.id, label = _a.label, isLabelHidden = _a.isLabelHidden, subLabel = _a.subLabel, isRequired = _a.isRequired, details = _a.details, validationResult = _a.validationResult, noBottomSpacing = _a.noBottomSpacing, maxLengthHidden = _a.maxLengthHidden, rest = __rest(_a, ["id", "label", "isLabelHidden", "subLabel", "isRequired", "details", "validationResult", "noBottomSpacing", "maxLengthHidden"]);
    var wrappedDetails = null;
    var errorMessageId = id + "-error";
    var hintId = id + "-hint";
    switch (validationResult) {
        case 'success':
            wrappedDetails = details && (React.createElement(InputSuccessMessage, null, details));
            break;
        case 'error':
            wrappedDetails = details && (React.createElement(InputErrorMessage, { id: errorMessageId }, details));
            break;
        default:
            wrappedDetails = details && (React.createElement(InputHint, { id: hintId }, details));
    }
    var commonInputProps = {
        isRequired: isRequired,
        validationResult: validationResult,
        'aria-errormessage': validationResult === 'error' ? errorMessageId : undefined,
        'aria-describedby': validationResult === undefined && details ? hintId : undefined,
        ref: ref,
    };
    return (React.createElement(FormElement, { inputId: id, label: React.createElement(InputLabelText, { isRequired: isRequired }, label), isLabelHidden: isLabelHidden, subLabel: subLabel && React.createElement(InputLabelSubText, null, subLabel), details: wrappedDetails, noBottomSpacing: noBottomSpacing }, rest.maxLength === undefined || maxLengthHidden ? (React.createElement(InputField, __assign({}, commonInputProps, rest))) : (React.createElement(LimitedTextInputField, __assign({ maxLength: rest.maxLength }, commonInputProps, rest)))));
});
TextInput.displayName = 'TextInput';
export default TextInput;
//# sourceMappingURL=TextInput.js.map